<div class="flex gap-3 max-h-16">
  <div
    class="flex flex-col items-center h-full border-r border-gray-300 dark:border-gray-700 pr-3 justify-center"
  >
    <strong>{{ listing().beds }}</strong>
    bed
  </div>

  <div
    class="flex flex-col items-center h-full border-r border-gray-300 dark:border-gray-700 pr-3 justify-center"
  >
    <strong>{{ baths() }}</strong>
    bath
  </div>

  @if (listing().den ?? listing().customFilters?.den) {
    <div
      class="flex flex-col items-center h-full border-r border-gray-300 dark:border-gray-700 pr-3 justify-center"
    >
      <strong>1</strong>
      den
    </div>
  }

  <div class="flex flex-col items-center h-full justify-center">
    <strong>{{ $safeNavigationMigration(listing().squareFeet?.total) | number }}</strong>
    sqft
  </div>

  @if (listing().garage?.cars) {
    <div
      class="flex flex-col items-center border-l border-gray-300 dark:border-gray-700 h-full justify-center pl-3"
    >
      <strong>
        {{ listing().garage?.cars }}

        @if (listing().garage?.golf) {
          +golf
        }
      </strong>
      garage
    </div>
  }
</div>
